module.exports = __webpack_public_path__ + "img/product_58.e3d76fb.webp";